import { Observable } from 'rxjs/Rx';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material';
import { Injectable, Component } from '@angular/core';

@Injectable()
export class ConfirmDialogService {

    config: MatDialogConfig = {
        disableClose: false,
        hasBackdrop: true,
        backdropClass: '',
        width: '500px',
        height: '',
        position: {
            top: '',
            bottom: '',
            left: '',
            right: ''
        }
    };

    constructor(private dialog: MatDialog) { }

    public confirm(title: string, message: string): Observable<boolean> {

        let dialogRef: MatDialogRef<ConfirmDialog>;

        dialogRef = this.dialog.open(ConfirmDialog, this.config);
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.message = message;

        return dialogRef.afterClosed();
    }
}

@Component({
    selector: 'confirm-dialog',
    template: `
        <h2 mat-dialog-title [innerHtml]="title"></h2>
        <mat-dialog-content>
            <p class="mat-body-1" [innerHtml]="message | nl2br"></p>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button type="button" mat-button mat-dialog-close>Cancel</button>
            <button type="button" mat-button (click)="dialogRef.close(true)">OK</button>
        </mat-dialog-actions>
    `,
})
export class ConfirmDialog {

    public title: string;
    public message: string;

    constructor(public dialogRef: MatDialogRef<ConfirmDialog>) {

    }
}



// WEBPACK FOOTER //
// ./Angular/app/_common/confirm.dialog.ts